import { useFlexiblePropertiesEntry } from '../../hooks/useFlexiblePropertiesEntry';

import { useAuth } from '../../components/AuthProvider';
import FlexiblePropertiesPage from '../../containers/FlexiblePropertiesPage';
import PropertiesPage from '../../containers/PropertiesPage';
import { ZRAMPropertiesPage } from '../../containers/ZRAMPropertiesPage';

const PropertiesRoute = () => {
  const { user } = useAuth();
  const { canAccessFlexibleProperties, isLoading } = useFlexiblePropertiesEntry();

  if (isLoading) {
    // Return null to avoid rendering an unknown page until the data is loaded.
    return null;
  }

  if (user?.isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  if (canAccessFlexibleProperties) {
    return <FlexiblePropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesRoute;
